import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, Router } from '@angular/router';
import { Case, Query } from '@telespot/sdk';
import { from, Observable, EMPTY, of } from 'rxjs';
import { mergeMap, tap, catchError } from 'rxjs/operators';

import { AuthService, DataService } from '../services';

@Injectable({
  providedIn: 'root',
})
export class CaseResolver  {
  constructor(private _dataService: DataService, private _authService: AuthService, private _router: Router) {}

  resolve(route: ActivatedRouteSnapshot): Observable<Case> {
    if (this._authService.currentUser?.isOnly('guest')) return EMPTY;

    const id = route.params['caseid'];
    const query = new Query(Case).include(['caseType.methodTypes.assetType', 'workspace', 'createdBy', 'organization']);

    return from(this._dataService.get(id, query)).pipe(
      mergeMap((_case) => {
        if (!_case) {
          this._router.navigate(['/page-not-found']);
          return EMPTY;
        }

        return of(_case);
      }),
      tap((_case) => {
        this._authService.setOrganizationFromId(_case.organization.id);
      }),
      catchError((error) => {
        console.error(`Failed to fetch case ${id}:`, error);
        this._router.navigate(['/page-not-found']);
        return EMPTY;
      })
    );
  }
}
